/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contenttype/contenttype_styles';



/* ========== ~~~~~~~~~~ CONTENT TYPE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ContentType extends Component {
	constructor(props) {
		super(props);
		this.state = { selected: false };
	}
	handleClick = (e) => {
		this.setState({ selected: this.state.selected ? false : true });
		this.props.handleClick(this.props.type)
	};
	render() {
		return (
	        <span className={`contenttype ${this.props.classes.contenttype} ${this.props.type} live-${this.props.isLive} ${this.props.indicatorType} ${this.props.indicatorType === 'sort' ? `selected-${this.state.selected}` : 'noToggling'}`} onClick={this.handleClick} content-type={this.props.type.toLowerCase()} >
	        	<span className={`contenttypeinner`}>
	            	<span className={`icon`}>{this.props.type}</span>
	            </span>
	        </span>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentType);